<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'master-fabric',
  components: { PageTable },
}
</script>
